import React from 'react';
import AdvancedSecurityDashboard from '../../components/security/AdvancedSecurityDashboard';

const AdvancedSecurityDashboardPage = () => {
  return (
    <div>
      <AdvancedSecurityDashboard />
    </div>
  );
};

export default AdvancedSecurityDashboardPage;
